// extracted by mini-css-extract-plugin
export default {"root":"root--1c7fb49","backToSearch":"backToSearch--2eaeb75"};